import { Box, Typography } from "@mui/material";
import React from "react";
import img from '../../images/EmpTestimonial.png'

export default function EmployerTestimonialCard() {
  return (
    <>
      <Box textAlign={'center'}>
        <Box sx={{background: '#F8FAFF',
border: '1px solid rgba(37, 68, 238, 0.5)',
borderRadius: '20px'}}>
          <Typography sx={{fontFamily: 'Inter',
fontWeight: 400,
fontSize: '14px',
lineHeight: '22px',
textAlign: 'center',
letterSpacing: '0.2px',
color: '#090909',px:5, pt:5,pb:8}}>
            Luctus felis sit lectus tristique diam ornare bibendum. Arcu auctor
            suspendisse luctus amet bibendum pellentesque lorem. Luctus felis
            sit lectus tristique diam ornare bibendum. Arcu auctor suspendisse
            luctus amet bibendum pellentesque{" "}
          </Typography>
        </Box>
        <Box>
            <Box mt={'-35px'}>
            <img src={img} alt="img" style={{height:'70px', width:'70px', borderRadius:'6px'}} />
            </Box>
            <Box>
                <Typography sx={{fontSize:'16px', fontWeight: 600, pt:1}}>Mang Oleh</Typography>
                <Typography>by | Lorem Ipsum</Typography>
            </Box>
        </Box>
      </Box>
    </>
  );
}
